import React from "react";
import "./UntranslatedContentError.scss";

/*
 * Pass this error component to an error boundary class such as ErrorBoundary to display an error message.
 * This message is not translated, so use this component only when the translation provider is not ready.
 */
export default function UntranslatedContentError(/*props*/) {

  const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;

  return (
    <div className={"UntranslatedContentError"}>
      <h1>Oops! Something went wrong...</h1>
      <p>
        We are truly sorry for this. If you would like to help, please send us more details and we will fix this shortly.
      </p>
      <p>
        <a href={"mailto:" + SUPPORT_EMAIL}>{SUPPORT_EMAIL}</a>
      </p>
    </div>
  );
}
